import { render, staticRenderFns } from "./imageModal.vue?vue&type=template&id=5337a9f2&scoped=true&"
import script from "./imageModal.vue?vue&type=script&lang=js&"
export * from "./imageModal.vue?vue&type=script&lang=js&"
import style0 from "./imageModal.vue?vue&type=style&index=0&id=5337a9f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5337a9f2",
  null
  
)

export default component.exports